import React from "react";
import styled from "styled-components";
import { CircleX } from "@sonder/ui/source/icons";
import { ButtonProps } from "@sonder/ui/source/styled/fragments/Button";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";

interface ChecklistItemDeleteProps extends ButtonProps {
  isVisible?: boolean;
}

const StyledCircleButton = styled(CircleButton)<ChecklistItemDeleteProps>`
  opacity: ${props => (props.isVisible ? 1 : 0)};
  pointer-events: ${props => (props.isVisible ? "all" : "none")};
`;

export const ChecklistItemDelete = ({
  isVisible,
  onClick,
}: ChecklistItemDeleteProps) => (
  <StyledCircleButton
    backgroundVariant="light"
    isVisible={isVisible}
    title="Delete this item"
    onClick={onClick}
  >
    <CircleX />
  </StyledCircleButton>
);
